import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { handleError } from '@src/utility/commonUtilityServices';
import { LABS_DATE_FILTER_API_URL, LABS_TOP_FILTER_API_URL, LABS_CATEGORY_DETAILS_API_URL, LABS_NET_CATEGORY_DETAILS_API_URL, LABS_EXPORT_DETAILS_REQUEST_URL, LABS_EXPORT_DETAILS_STATUS_URL, LABS_EXPOR_LINK_DETAILS_URL} from './apiUrlConstants';

const _httpService = new HttpService();
const cache = new Map();

if(checkIsInternal()){
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else{
 _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
 //_httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}

export const getDateFilterData = (): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response: any = await _httpService.get(LABS_DATE_FILTER_API_URL);
      resolve(response);
    } catch (e) {
      handleError('Error in getDateFilterData', e);
      reject(new Error('Failed to fetch date filter data. Please try again later.'));
    }
  });
};

export const getTopFilterData= async (payload:any) =>{    
    const url = LABS_TOP_FILTER_API_URL;
    const hasTin = payload?.NetworkLeverTopFilter?.tin;
    let finalUrl = hasTin ? url + "TIN" : url + "HCO";
    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getLabcategoryData= async (payload:any) =>{    
    const url = LABS_CATEGORY_DETAILS_API_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getNetLabcategoryData= async (payload:any) =>{    
    const url = LABS_NET_CATEGORY_DETAILS_API_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getExporDetails= async (payload:any) =>{    
    const url = LABS_EXPORT_DETAILS_REQUEST_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getExporDetailsStatus= async (payload:any) =>{    
    const url = LABS_EXPORT_DETAILS_STATUS_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}


export const getExporDetailsLinks= async (payload:any) =>{    
    const url = LABS_EXPOR_LINK_DETAILS_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getLabCatViewData= async (payload:any) =>{    
    const url = LABS_NET_CATEGORY_DETAILS_API_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}
